import { FeatureManager } from '../../core/feature-flags/feature-manager.service';
import { SessionService } from '../../core/services/session.service';
import { UtilityService } from '../../core/services/utility.service';
import templateUrl from './login.component.html';
import "./login.component.less";

/**
 * A login component that requests credentials and persists them in the session.
 * Note: This is unused currently because a full form POST is still required for
 * submitting the form, and MVC provides the best integration for this use case.
 */
export const LoginComponent = {
    templateUrl,
    bindings: {
        returnUrl: "@",
        externalReferrer: "@",
    },
    transclude: true,
    controller: class LoginComponent {
        signInMethod = "Apex";
        returnUrl: string;
        externalReferrer: string;
        externalSignInEnabled: boolean;
        userName: string;
        password: string;
        rememberMe: boolean;
        loginError: string;
        constructor(private featureManager: FeatureManager,
            private sessionService: SessionService, private utilityService: UtilityService,
            public apexDeployStage: string) {
            'ngInject'
        }

        $onInit() {
            this.featureManager.ensureLoaded().then(() =>
                this.configureSignInFeatures());
        }

        configureSignInFeatures() {
            if (this.featureManager.isEnabled("account.externalSignIn")) {
                this.externalSignInEnabled = true;
                if (this.externalReferrer) {
                    // Revert Apex hard-coded link if a third-party sign in referred us.
                    this.signInMethod = null;
                }
            } else {
                this.externalSignInEnabled = false;
            }
        }

        onSubmit() {
            // rememberMe is non-standard to the interface, and will only be saved for the v1 session service.
            const signingIn = this.sessionService.signIn(this.userName, this.password, this.rememberMe)
                .then(token => {
                    // Redirect to home page, or to page the user was originally trying to access.
                    // The form submission takes care of reloading the page on its own.
                    //window.location = this.returnUrl || ""
                })
                .catch(ex => {
                    // Display exception message.
                    this.loginError = ex && ex.Messages ? ex.Messages : [this.utilityService.getExceptionMessage(ex)]
                })
            this.utilityService.showLoadingUntilResolved(signingIn)
        }

        onExternalLogin(providerName) {
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(this.sessionService.externalSignIn(providerName, null),
                    `Sign in Failed: ${providerName}`));
        }
    }
}
